<template>
  <div class="container" v-if="!isEdit || (isEdit && stadiumModel.name != '')">
    <md-card>
      <md-card-header class="md-card-header-icon md-card-header-blue">
        <div class="card-icon">
          <md-icon>domain</md-icon>
        </div>
        <h4 class="title">{{ isEdit ? $t("stadiums.edit.title") : $t("stadiums.create.title") }}</h4>
      </md-card-header>

      <md-card-content>
        <!-- Name -->
        <md-field :class="{'md-error': $v.stadiumModel.name.$error && $v.stadiumModel.name.$invalid, 'md-valid': !$v.stadiumModel.name.$error && !$v.stadiumModel.name.$invalid}">
          <label>{{ isEdit ? $t("stadiums.edit.name") : $t("stadiums.create.name") }}</label>
          <md-input v-model.trim="$v.stadiumModel.name.$model"></md-input>

          <slide-y-down-transition>
            <md-icon class="error" v-show="$v.stadiumModel.name.$error && $v.stadiumModel.name.$invalid">close</md-icon>
          </slide-y-down-transition>
          <slide-y-down-transition>
            <md-icon class="success" v-show="!$v.stadiumModel.name.$error && !$v.stadiumModel.name.$invalid">done</md-icon>
          </slide-y-down-transition>
        </md-field>
      </md-card-content>

      <md-card-actions class="actions">
        <md-button @click="save()" class="md-info" :disabled="loading">
          <span>{{ isEdit ? $t("stadiums.edit.edit") : $t("stadiums.create.create") }}</span>
        </md-button>
        <md-button class="md-simple md-danger" v-if="isEdit" @click="stadiumDelete" :disabled="loading">
          {{ $t("stadiums.edit.delete") }} <md-icon>delete</md-icon>
        </md-button>
      </md-card-actions>
    </md-card>
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import { SlideYDownTransition } from "vue2-transitions";

export default {
  components: {
    SlideYDownTransition
  },
  data() {
    return {
      loading: false,
      stadiumId: "",
      stadiumModel: {
        name: ""
      }
    };
  },
  computed: {
    isEdit() {
      return this.$route.params.id != undefined;
    }
  },
  mounted() {
    if (this.isEdit) {
      this.stadiumId = this.$route.params.id;

      if (this.$store.state.StuffModule.stadiums.length === 0) {
        this.loading = true;
        this.$store.dispatch("getStadiums").then(_ => {
          const stadium = this.$store.getters.getStadiumById(this.stadiumId);
          this.stadiumModel = { ...stadium };
          this.loading = false;
        });
      } else {
        const stadium = this.$store.getters.getStadiumById(this.stadiumId);
        this.stadiumModel = { ...stadium };
      }
    }
  },
  methods: {
    async save() {
      this.$v.$touch();

      if (!this.$v.$invalid) {
        if (this.isEdit) {
          this.loading = true;
          const response = await this.$store.dispatch("stadiumUpdate", this.stadiumModel);
          if (response != undefined) {
            this.$notify({
              message: this.$t(`notifications.stadiums.update`),
              icon: 'add_alert',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success'
            })
          } else {
            this.$store.dispatch("openModalError")
          }
          this.loading = false;
        } else {
          this.loading = true;
          const response = await this.$store.dispatch("stadiumCreate", this.stadiumModel);
          if (response != undefined) {
            this.$notify({
              message: this.$t(`notifications.stadiums.create`),
              icon: 'add_alert',
              horizontalAlign: 'right',
              verticalAlign: 'bottom',
              type: 'success'
            })
          } else {
            this.$store.dispatch("openModalError")
          }
          this.loading = false;
        }
        return;
      }
      return;
    },
    async stadiumDelete() {
      if (this.isEdit) {
        this.loading = true;
        const response = await this.$store.dispatch("stadiumDelete", this.stadiumModel.id);
        if (response != undefined) {
          this.$notify({
            message: this.$t(`notifications.stadiums.remove`),
            icon: 'add_alert',
            horizontalAlign: 'right',
            verticalAlign: 'bottom',
            type: 'success'
          })
          this.$router.push("/list/stadiums");
        } else {
          this.$store.dispatch("openModalError")
        }
        this.loading = false;
      } else {
        return;
      }
    }
  },
  watch: {
    isEdit(newVal) {
      if (newVal === false) {
        this.stadiumModel = { name: "" };
        this.$v.$reset()
      }
    }
  },
  validations: {
    stadiumModel: {
      name: {
        required
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.actions {
  display: flex;
  justify-content: space-between;
}
</style>
